

















































import { Vue, Component, PropSync } from 'vue-property-decorator'
import { Categoria } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DialogoSeletorDeCategorias from './DialogoSeletorDeCategorias.vue'

@Component({
	components: {
		DialogoSeletorDeCategorias,
	},
})
export default class ListaDeCategorias extends Vue  {
	@PropSync('value') categorias!: Categoria[]

	remover(indice: number) {
		this.categorias.splice(indice, 1)
	}

	inserirCategoria(categoria: Categoria) {
		const jaEstaNaInclusa = this.categorias.some(
			({ id }) => categoria.id === id,
		)
		if (jaEstaNaInclusa) {
			AlertModule.setError(`${categoria.nome} já consta na lista de categorias`)
			return
		}
		this.$emit('input', [
			...this.categorias,
			categoria,
		])
	}

	setarCategorias(categoriasSelecionadas: Categoria[]) {
		categoriasSelecionadas = categoriasSelecionadas.filter(categoriaSelecionada => !this.categorias.map(categoria => categoria.id).includes(categoriaSelecionada.id))

		this.$emit('input', [
			...this.categorias,
			...categoriasSelecionadas,
		])
	}

	limparSelecao() {
		this.$emit('input', [])
	}
}

